import { Button } from 'antTheme/ButtonComponentTheme';
import { Tabs } from 'antTheme/TabsComponentTheme';
import { DatePicker } from 'antTheme/DatePickerComponentTheme';
import { Table } from 'antTheme/TableComponentTheme';
import { Pagination } from 'antTheme/PaginationComponentTheme';

export const antComponentsTheme = {
  Button: Button,
  Tabs: Tabs,
  DatePicker: DatePicker,
  Table: Table,
  Pagination: Pagination,
};
